import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Layout } from "@/components/layout/Layout";
import { ScrollManager } from "@/components/ScrollManager";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Partnernetzwerk from "@/pages/Partnernetzwerk";
import Kontakt from "@/pages/Kontakt";
import ServiceDetail from "@/pages/ServiceDetail";
import Admin from "@/pages/Admin";
import { CmsContentProvider } from "@/cms/CmsContentProvider";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <CmsContentProvider>
          <Routes>
            <Route path="/admin" element={<Admin />} />
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/ueber-uns" element={<About />} />
              <Route path="/partnernetzwerk" element={<Partnernetzwerk />} />
              <Route path="/gutachten" element={<ServiceDetail slug="gutachten" />} />
              <Route path="/versicherung" element={<ServiceDetail slug="versicherung" />} />
              <Route path="/kfz-zulassung" element={<ServiceDetail slug="kfz-zulassung" />} />
              <Route path="/services" element={<ServiceDetail slug="services" />} />
              <Route path="/kontakt" element={<Kontakt />} />
              <Route path="*" element={<Home />} />
            </Route>
          </Routes>
        </CmsContentProvider>
        <Toaster richColors position="top-center" closeButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
